// import { auth } from '../firebase/firebase-config';
// import { Outlet } from "react-router-dom"
// import Login from './Login';
// const [authUser, loading] = useAuthState(auth)


// const ProtectedRoutes = () => {
//     const isAuth = authUser;
//     console.log(isAuth);
//     return isAuth ? <Outlet /> : <Login />
// }

// export default ProtectedRoutes;


import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, isAuthenticated, ...rest }) => (

    <Route
        {...rest}
        render={(props) =>
            isAuthenticated ? (
                <Component {...props} />
            ) : (
                <Redirect to="/Login" />
            )
        }
    />
);

export default ProtectedRoute;